import '@material-ui/core/Table';
import '@material-ui/core/TableBody';
import '@material-ui/core/TableCell';
import '@material-ui/core/TableRow';
import '../../components/dialogs/Details';
import '../../components/PricingDetails';

export { SuspenseAgreement } from './Agreement';
export { SuspenseFaktablad } from './Faktablad';
export { SuspenseLetter } from './Letter';
export { SuspensePurchaseInfo } from './PurchaseInfo';
export { SuspenseQuiz } from './Quiz';
export { SuspenseReferral } from './Referral';
